import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { AvantoSessionService } from 'src/app/services/avanto-session.service';
import { CartObject } from 'src/app/avantoeats-util/models/cart/CartObject';
import { AvantoRoutingService } from 'src/app/services/avanto-routing.service';
import { SessionObject } from 'src/app/avantoeats-util/models/session/SessionObject';
import Swal from 'sweetalert2'
import { AvantoRestaurantsService } from 'src/app/services/avanto-restaurants.service';

@Component({
  selector: 'app-cart-content',
  templateUrl: './cart-content.component.html',
  styleUrls: ['./cart-content.component.scss']
})
export class CartContentComponent implements OnInit, OnDestroy {

  @Input() nonEditable: boolean;

  cartObj: CartObject = {} as CartObject;
  isDelivery: boolean;
  selectedRestaurantId:string;
  disableRows: boolean;
  avantoSessionSubscription: Subscription;

  constructor(private avantoSession: AvantoSessionService, private avantoRoute: AvantoRoutingService, private avantoRestaurant:AvantoRestaurantsService) { }

  ngOnInit() {
    this.avantoSessionSubscription = this.avantoSession.sessionSubject.subscribe((session) => {
      if(session!=null){
        this.isDelivery = session.orderType == SessionObject.ORDER_TYPE_DELIVERY;
        this.cartObj = session.cart;
        if(session.restaurantInformation != null){
          this.selectedRestaurantId = session.restaurantInformation.restaurantId;
        }
      }
    })
  }

  ngOnDestroy() {
    this.avantoSessionSubscription.unsubscribe();
  }

  editCart(cartItem) {
    if (!this.nonEditable) {
      this.avantoRestaurant.requestMenuItemEdit(this.selectedRestaurantId, cartItem)
      return;
    }
  }

  removeItemFromCart(cartItemId) {
    if (!this.nonEditable) {
      this.disableRows = true;
      this.avantoSession.removeItemFromSession([cartItemId])
        .then(() => {
          this.disableRows = false;
        })
        .catch(() => {
          const Toast = Swal.mixin({ toast: true, position: 'bottom-end', showConfirmButton: false, timer: 3000 })
          Toast.fire({ type: 'error', title: 'Could not remove item from cart. Please, try again.' })
          this.disableRows = false;
        });
    }
  }
}
